import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { LocalDeviceDetectorService } from 'dmmp-services'
import { ActivatedRoute, Router } from '@angular/router'
import { FilterService } from 'dmmp-services'
import { PlatformLocation } from '@angular/common'

@Component({
  selector: 'dmmp-filters-programmes',
  templateUrl: './filters-programmes.component.html',
})
export class FiltersProgrammesComponent
  implements OnInit, OnChanges, AfterViewInit {
  @ViewChildren('checkboxesFilters') checkboxesFilters: QueryList<ElementRef>
  @Input() form: FormGroup
  @Input() data: any
  @Input() identifier: string
  @Input() openFilters: boolean
  @Input() currentFilters: any
  @Output() changeSelectedValues = new EventEmitter()
  @Output() uncheckAllValues = new EventEmitter()
  @Output() showFilters = new EventEmitter()
  @Output() redirectPage = new EventEmitter()
  formOptions: FormArray
  counter: number
  textMobile = {
    title: 'Filtrar por',
    applyFilter: 'Aplicar Filtros',
    clearFilter: 'Borrar todo',
  }
  queryString = ''
  @Input() relateUrls = {
    academicOfferUrl: '',
    programsFilterUrl: '',
  }

  constructor(
    public localDeviceDetector: LocalDeviceDetectorService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private location: PlatformLocation
  ) {}

  ngOnInit() {
    this.isMobile()
    this.formOptions = this.form.get('options') as FormArray
  }

  ngOnChanges(changes: SimpleChanges) {
    this.verifyFilters(this.currentFilters)
  }

  ngAfterViewInit(): void {
    this.filterService.selectedUrlFilter(
      this.data,
      this.relateUrls,
      this.checkboxesFilters,
      this.currentFilters,
      this.formOptions
    )
    this.checkTopic()
    this.changeSelectedValues.emit(this.data?.vocabulary_content_type)
  }

  checkTopic(): void {
    if (this.activatedRoute.snapshot.queryParams.topic) {
      this.filterService.checkQueryTopic(
        this.data,
        this.checkboxesFilters,
        this.formOptions,
        this.activatedRoute.snapshot.queryParams.topic
      )
    }
  }

  isMobile(): void {
    if (this.localDeviceDetector.isMobile()) {
      this.data?.vocabularies?.forEach((item, index) => {
        if (index > 0) {
          item.vocabulary.isCollapsed = true
        }
      })
    } else {
      this.data?.vocabularies?.forEach((item) => {
        item.vocabulary.isCollapsed = false
      })
    }
  }

  onCheckboxChange(event, path, label, vocabularyName) {
    if (this.data?.vocabulary_content_type === 'event') {
      if (event.target.checked) {
        this.filterService.pushOptionForm(
          label,
          event.target.value,
          path,
          vocabularyName,
          this.formOptions
        )
      } else {
        this.filterService.uncheckOption(event.target.value, this.formOptions)
      }
    } else {
      if (this.activatedRoute.snapshot.queryParams.q) {
        this.queryString = this.activatedRoute.snapshot.queryParams.q
      }
      if (event.target.checked) {
        if (event.target.value === 'vocabulary') {
          this.filterService.selectedCategory(
            this.data,
            path,
            vocabularyName,
            true,
            this.formOptions,
            this.checkboxesFilters
          )
        } else {
          this.filterService.pushOptionForm(
            label,
            event.target.value,
            path,
            vocabularyName,
            this.formOptions
          )
        }
        this.counter = this.formOptions.length
        if (path && this.counter === 1 && this.queryString === '') {
          this.router.navigate([path])
          this.redirectPage.emit()
        }
        if (
          this.location.pathname !== this.relateUrls.programsFilterUrl &&
          this.counter > 1 &&
          this.queryString === ''
        ) {
          this.router.navigate([this.relateUrls.programsFilterUrl])
          this.redirectPage.emit()
        }
      } else {
        if (event.target.value === 'vocabulary') {
          this.filterService.selectedCategory(
            this.data,
            path,
            vocabularyName,
            false,
            this.formOptions,
            this.checkboxesFilters
          )
        } else {
          this.filterService.uncheckOption(event.target.value, this.formOptions)
        }
        this.counter = this.formOptions.length
        if (this.counter === 1 && this.queryString === '') {
          this.router.navigate([this.formOptions.value[0].path])
          this.redirectPage.emit()
        }
        if (this.counter === 0 && this.queryString === '') {
          this.router.navigate([this.relateUrls.programsFilterUrl])
          this.redirectPage.emit()
        }
      }
    }
    this.changeSelectedValues.emit(this.data?.vocabulary_content_type)
  }

  uncheckAll() {
    this.checkboxesFilters.forEach((element) => {
      element.nativeElement.checked = false
    })
    while (this.formOptions.length !== 0) {
      this.formOptions.removeAt(0)
    }
    this.counter = 0
    this.uncheckAllValues.emit()
  }

  verifyFilters(currentFilter): void {
    if (currentFilter.options?.length === 0) {
      this.checkboxesFilters?.forEach((element) => {
        element.nativeElement.checked = false
      })
      if (this.formOptions) {
        while (this.formOptions?.length !== 0) {
          this.formOptions.removeAt(0)
        }
      }
      this.counter = 0
    } else {
      this.formOptions?.controls?.forEach((option) => {
        const index = currentFilter?.options?.findIndex((currentOption) => {
          return option.value.id === currentOption.id
        })
        if (index === -1) {
          const indexToDelete = this.formOptions.controls.findIndex(
            (optionToDelete) => {
              if (option.value.id !== 'vocabulary') {
                return optionToDelete.value.id === option.value.id
              }
            }
          )
          this.formOptions.removeAt(indexToDelete)
        }
      })
      this.checkboxesFilters?.forEach((checkbox) => {
        const index = currentFilter.options?.findIndex((option) => {
          return checkbox.nativeElement.id === option.id
        })
        if (index === -1) {
          if (!checkbox.nativeElement.id.includes('vocabulary')) {
            checkbox.nativeElement.checked = false
          }
        }
      })
    }
  }
}
